import React from 'react';
import { useTranslation } from 'react-i18next';

import { WebModal } from '@components/Modals/WebModal.web';
import { Box, Text } from '@components/Restyle';
import Button from '@components/shared/Button/Button';

interface TeamPlanConfirmModalProps {
  showModal: boolean;
  onClose?: () => void;
  onPress: () => void;
  buttonText: string;
  title: string;
  message: string | JSX.Element | React.ReactNode;
  cancelButtonText?: string;
}

export const TeamPlanConfirmModal: React.FC<TeamPlanConfirmModalProps> = ({
  showModal,
  onClose,
  onPress,
  buttonText,
  title,
  message,
  cancelButtonText = '',
}) => {
  const { t } = useTranslation();
  // cancelButtonText defaults to '', not undefined; ?? would never fall back to translated text
  const cancelLabel = cancelButtonText ? cancelButtonText : t('shared:cancel'); // NOSONAR

  return (
    <WebModal
      title={title}
      visible={showModal}
      width={483}
      height={message !== '' ? 184 : undefined}>
      <>
        {message !== '' && (
          <Text variant='bodySecondary' marginHorizontal='m' marginVertical='m'>
            {message}
          </Text>
        )}
        <Box
          flexDirection='row'
          flex={1}
          alignItems='flex-end'
          paddingHorizontal='m'
          mb='m'
          mt='m'
          alignSelf='flex-end'>
          <Button
            marginRight='m'
            onPress={onClose}
            borderColor='textPrimary'
            isSmall
            width={125}
            height={48}
            backgroundColor='white'>
            <Text variant='buttonLabel' color='textPrimary'>
              {cancelLabel}
            </Text>
          </Button>
          <Button
            onPress={onPress}
            borderColor='textPrimary'
            isSmall
            width={125}
            height={48}
            backgroundColor='black'>
            <Text variant='buttonLabel' color='white'>
              {buttonText}
            </Text>
          </Button>
        </Box>
      </>
    </WebModal>
  );
};
